import { Container, Flex, Stack, Text } from '@chakra-ui/react';

import { Playlist } from '~/@types/tsl-types';
import GoBackButton from '~/components/ui/GoBackButton';
import Titles from '~/components/ui/Titles';

type Props = {
  playlist: Playlist;
};

function PlaylistContent({ playlist }: Props) {
  return (
    <Container maxW='2xl'>
      <Stack display='flex' alignItems='center' minW='100%'>
        <Flex alignItems='baseline'>
          <GoBackButton />

          <Text fontFamily='heading' fontSize='32px' mb={6} fontWeight='500'>
            {playlist.name}
          </Text>
        </Flex>

        <Titles songs={playlist.songs} minSongs={16} />
      </Stack>
    </Container>
  );
}

export default PlaylistContent;
